import React, { ReactNode } from "react";

const Panel: React.FC<{children: ReactNode}> = ({children}) => {
	return (
		<div className='flex flex-col items-center bg-white shadow-leap rounded-2xl w-full px-5 py-8 lg:px-12 lg:py-12'>{children}</div>
	);
};

export default Panel;
